<template>
    <div class="component">
        <label v-if="label" v-html="label"></label>
        <input type="file"
               class="form-control file-input"
               ref="fileInput"
               v-bind:id="id"
               v-on:input="onInputChanged"
               :accept="accept">
    </div>
</template>

<script type="text/babel">
    import FileService from '@/services/fileService'

    export default {
        name: 'components-forms-file-index',
        watch: {},
        props: {
            value: undefined,
            id: undefined,
            label: {
                default: undefined
            },
            placeholder: {
                default: undefined
            },
            accept: {
                default: undefined
            }
        },
        data() {
            return {
                newValue: undefined
            }
        },
        methods: {
            onInputChanged(value) {
                let input = this.$refs['fileInput'];

                if (input.files.length > 0) {
                    let file = input.files[0];
                    FileService.convertFileToString(file)
                        .then((fileString) => {

                            this.newValue = {
                                fileData: fileString,
                                fileMimeType: file.type,
                                fileName: file.name
                            };
                            this.onChange();
                        });
                } else {
                    this.newValue = undefined;
                    this.onChange();
                }
            },
            onChange() {
                this.$emit('input', this.newValue);
            }
        },
        computed: {},
        created() {
            this.newValue = this.value;
        },
        mounted() {
        },
        beforeDestroy() {
        },
        mixins: [],
        components: {}
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .file-input {
        margin-bottom: 1em;
        padding-bottom: 32px;
    }
</style>
